import Link from 'react-router-dom/Link';

const Explore = () => {
  return (
    <section id="explore">
      <div className="container">
        <div className="row row__column">
          <div className="section__title">
            <h2>
              Explore <span className="purple">Books</span>
            </h2>
            <Link to="/books">
              <button className="btn">Browse All Books</button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore;
